import streetviewImg from "@/assets/images/maps/google-street-view-icon-5.png";
import Utils from "@/helpers/Utils";

/**
 * @description Genera el contenido html del la barra de botones del mapa
 * @param {HTMLDivElement} controlDiv Json object con las propiedades de un recurso
 * @param {Function} callback funcion para recoger los datos del infowindow desde el componente que lo invoca
 */
export const customMapsControl = function (controlDiv, callback) {
	const $docFragment = document.createDocumentFragment();
	const $controlMapDivContent = document.createElement("div");
	$controlMapDivContent.style.cssText = `margin-top: 12px; margin-left: 4px`;
	const $button1 = document.createElement("button"),
		$button2 = document.createElement("button"),
		$button3 = document.createElement("button"),
		$button4 = document.createElement("button"),
		$button5 = document.createElement("button"),
		$button6 = document.createElement("button"),
		$button7 = document.createElement("button");

	const $ul = document.createElement("ul");
	const $ul2 = document.createElement("ul");
	$button3.setAttribute("id", "btn-toggle-routes");
	$ul2.setAttribute("id", "ul-map-routes");
	Utils.customizeMediaQueryUl($ul2);
	$ul.setAttribute("id", "ul-map-types");
	$ul.style.cssText = `
    display: none;
    background-color: rgb(255, 255, 255);
    line-height: 1.8em;
    margin: 5px 0px 15px;
    padding: 10px;
    width: 150px;`;

	const mapTypes = ["Default", "Dark", "Hybrid", "Satellite", "Terrain"];
	mapTypes.forEach((m) => {
		const $li = document.createElement("li");
		const $span = document.createElement("span");
		const $avatar = document.createElement("img");
		let mapType = "";
		switch (m) {
			case "Default":
				$avatar.setAttribute("src", require("@/assets/images/maps/roadmap.jpg"));
				mapType = "roadmap";
				break;
			case "Dark":
				$avatar.setAttribute("src", require("@/assets/images/maps/night_mode.jpg"));
				mapType = "dark";
				break;
			case "Hybrid":
				$avatar.setAttribute("src", require("@/assets/images/maps/hybrid.jpg"));
				mapType = "hybrid";
				break;
			case "Satellite":
				$avatar.setAttribute("src", require("@/assets/images/maps/satellite.jpg"));
				mapType = "satellite";
				break;
			case "Terrain":
				$avatar.setAttribute("src", require("@/assets/images/maps/terrain.jpg"));
				mapType = "terrain";
				break;
			default:
				break;
		}

		$avatar.style.cssText = `width: 24px;height: auto; margin-right: 10px;`;
		$span.innerHTML = m;
		$li.appendChild($avatar);
		$li.appendChild($span);
		$ul.appendChild($li);
		$li.style.cssText = `
        border: 1px solid #F3F3F3;
        padding: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: start;
        font-size: 16px`;

		$li.addEventListener("click", (e) => {
			this.changeMapType(mapType);
			document.querySelector("#ul-map-types").style.display = "none";
		});
	});

	$button1.title = this.mapAppearanceText;
	$button2.title = this.$t("Routing.Buttons.ExportRoute");
	$button3.title = this.$t("Routing.RouteResult.HideRoutes");
	$button4.title = this.$t("Routing.RouteResult.Title");
	$button5.title = this.$t("Routing.Buttons.Schedule");
	$button6.title = this.$t("Routing.Title.RoutingHistory");
	$button7.title = this.$t("Territories.ViewTerritories");

	//Add icons to btn
	addIconToBtn($button1, "icon-map");
	addIconToBtn($button2, "icon-download");
	addIconToBtn($button3, "icon-eye-off");
	addIconToBtn($button4, "icon-clipboard");
	addIconToBtn($button5, "icon-calendar");
	addIconToBtn($button6, "icon-arrow-left");
	addIconToBtn($button7, "icon-layers");

	// Add Styles to button
	addStyleToBtn($button1);
	addStyleToBtn($button2);
	addStyleToBtn($button3);
	addStyleToBtn($button4);
	addStyleToBtn($button5);
	addStyleToBtn($button6);
	addStyleToBtn($button7);

	$button7.addEventListener("click", (e) => {
		this.showTerritoriesModal();
	});

	// Set button events
	$button6.addEventListener("click", (e) => {
		this.$router.back();
	});

	$button5.addEventListener("click", (e) => {
		this.openScheduleModal();
	});
	$button4.addEventListener("click", (e) => {
		this.popupActive = true;
	});
	$button3.addEventListener("click", (e) => {
		const btnRoutes = document.getElementById("btn-toggle-routes");
		this.showRoutes = !this.showRoutes;
		document.getElementById("ul-map-types").style.display = "none";
		if (!this.showRoutes) {
			btnRoutes.title = this.$t("Routing.RouteResult.SeeRoutes");
			btnRoutes.innerHTML = "";
			addIconToBtn(btnRoutes, "icon-eye");
		} else {
			btnRoutes.title = this.$t("Routing.RouteResult.HideRoutes");
			btnRoutes.innerHTML = "";
			addIconToBtn(btnRoutes, "icon-eye-off");
		}
	});
	$button2.addEventListener("click", (e) => {
		this.exportModal();
	});
	$button1.addEventListener("click", (e) => {
		if (document.getElementById("ul-map-types").style.getPropertyValue("display") === "block") {
			document.getElementById("ul-map-types").style.display = "none";
		} else {
			document.getElementById("ul-map-types").style.display = "block";
		}
		this.showRoutes = false;
	});
	$docFragment.appendChild($button6);
	$docFragment.appendChild($button1);
	$docFragment.appendChild($button2);
	$docFragment.appendChild($button3);
	$docFragment.appendChild($button4);
	$docFragment.appendChild($button5);
	if (this.selectedRoutingType === "TOUR_PLANNING") {
		$docFragment.appendChild($button7);
	}
	$docFragment.appendChild($ul);
	$docFragment.appendChild($ul2);
	$controlMapDivContent.appendChild($docFragment);
	controlDiv.appendChild($controlMapDivContent);
	this.showRoutes = true;
};

function addStyleToBtn(button) {
	button.style.backgroundColor = "#fff";
	button.style.border = "2px solid #fff";
	button.style.borderRadius = "3px";
	button.style.boxShadow = "0 1px 6px rgba(0,0,0,.3)";
	button.style.cursor = "pointer";
	button.style.marginTop = "8px";
	button.style.marginBottom = "22px";
	button.style.textAlign = "center";
	button.style.color = "rgb(25,25,25)";
	button.style.fontFamily = "Roboto,Arial,sans-serif";
	button.style.fontSize = "14px";
	button.style.lineHeight = "38px";
	button.style.paddingLeft = "5px";
	button.style.paddingRight = "5px";
	button.style.marginLeft = "2px";
	button.style.width = "45px";
	button.style.height = "45px";
}

export function addIconToBtn(button, iconName = "icon-info") {
	const $span = document.createElement("span");
	const $i = document.createElement("i");
	// add or remove multiple classes using spread syntax
	const cls = ["vs-icon", "notranslate", "icon-scale", "vs-button--icon", "feather", iconName];
	$i.classList.add(...cls);
	$i.style.fontSize = "20px";
	$span.appendChild($i);
	button.appendChild($span);
}

export const generateInfowindowContentPoint = function (infoWindowData, markerType = "routed") {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	let $headerInfoWindowContent = document.createElement("div");
	$headerInfoWindowContent.className = "flex items-center justify-between";
	$infowindowDivContent.style.cssText = markerType === "norouted" ? "" : "text-align: justify; position: relative"; // Añadido para posicionar el botón de cierre// Crear el botón de cierre
	let $closeButton = document.createElement("button");
	$closeButton.textContent = "X";
	$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
	$closeButton.addEventListener("click", () => {
		this.infoWindowSelected.close();
	});
	// Crear el botón de "Más Detalle"
	let $detailButton = document.createElement("button");
	$detailButton.style.cssText =
		"display: block; margin-left: 4px; padding: 2px 2px; background-color: #ff9800; color: white; border: none; cursor: pointer; border-radius: 5px; display: flex; align-items: center;";
	$detailButton.setAttribute("title", this.$t("ViewMore") + " " + this.$t("Information"));
	$detailButton.innerHTML = `
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="5" r="2" fill="white"/>
			<circle cx="12" cy="12" r="2" fill="white"/>
			<circle cx="12" cy="19" r="2" fill="white"/>
		</svg>`;
	$detailButton.addEventListener("click", () => {
		this.showVisitPointDetails(infoWindowData);
	});
	// Crear el contenedor para la imagen y el botón
	let $contentImg = document.createElement("div");
	$contentImg.className = "flex items-center justify-end mt-4";
	let $title = document.createElement("h4");
	$title.className = "mb-2";
	let $subtitle = document.createElement("p");
	$title.textContent = markerType === "norouted" ? this.$t("Routing.Map.VisitPoints.Dropped") : this.$t("VisitPoint");
	$subtitle.innerHTML = `<strong>${this.$t("Routing.Map.VisitPoints.Identifier")}</strong>: ${
		infoWindowData.identification
	}`;
	let $name = document.createElement("p");
	let $visitPoint = document.createElement("p");
	let $avatar = document.createElement("img");
	let $estimatedTimeDepart = document.createElement("p");
	let $distanceFromPrevious = document.createElement("p");
	let $totalDistanceTraveled = document.createElement("p");
	let $waitingTime = document.createElement("p");
	let $estimatedStartTask = document.createElement("p");
	$avatar.setAttribute("src", streetviewImg);
	$avatar.setAttribute("alt", "StreetView");
	$avatar.setAttribute("title", "StreetView");
	$subtitle.className = "pb-1";
	$visitPoint.className = "pb-1";
	$name.className = "pb-1";
	$estimatedTimeDepart.className = "pb-1";
	$distanceFromPrevious.className = "pb-1";
	$totalDistanceTraveled.className = "pb-1";
	$waitingTime.className = "pb-1";
	$estimatedStartTask.className = "pb-1";
	$avatar.className = "h-8 w-8 cursor-pointer streetview-routing-map";
	$name.innerHTML =
		markerType === "routed"
			? `<strong>${this.$t("Routing.Table.EstimatedTimeArrival")}:</strong> ${
					infoWindowData.estimated_time_arrival
			  }`
			: ``;
	$waitingTime.innerHTML = `<strong>${this.$t("Routing.Table.WaitingTime")}</strong>: ${infoWindowData.waiting_time}`;
	$estimatedStartTask.innerHTML = `<strong>${this.$t("Routing.Table.EstimatedStartTask")}</strong>: ${
		infoWindowData.estimated_start_task
	}`;
	$visitPoint.innerHTML = `<strong>${this.$t("Routing.Table.TimeService")}</strong>: ${infoWindowData.time_service}`;
	$estimatedTimeDepart.innerHTML =
		markerType === "routed"
			? `<strong>${this.$t("Routing.Table.EstimatedDepartureTime")}:</strong> ${
					infoWindowData.estimated_time_depart
			  }`
			: ``;
	$distanceFromPrevious.innerHTML =
		markerType === "routed"
			? `<strong>${this.$t("Routing.Table.DistanceFromPrevious")}:</strong> ${parseFloat(
					infoWindowData.distance_from_previous
			  ).toFixed(2)}`
			: ``;
	$totalDistanceTraveled.innerHTML =
		markerType === "routed"
			? `<strong>${this.$t("Routing.Table.TotalDistanceTraveled")}:</strong> ${parseFloat(
					infoWindowData.total_distance_traveled
			  ).toFixed(2)}`
			: ``;
	$docFragment.appendChild($subtitle);
	$docFragment.appendChild($name);
	$docFragment.appendChild($waitingTime);
	$docFragment.appendChild($estimatedStartTask);
	$docFragment.appendChild($visitPoint);
	$docFragment.appendChild($estimatedTimeDepart);
	$docFragment.appendChild($distanceFromPrevious);
	$docFragment.appendChild($totalDistanceTraveled);
	if (this.selectedRoutingType === "TOUR_PLANNING") {
		let $territory = document.createElement("p");
		$territory.className = "pb-1";
		$territory.innerHTML = `<strong>${this.$t("Territories.TerritoryID")}</strong>: ${infoWindowData.territory_id}`;
		$docFragment.appendChild($territory);
	}
	$contentImg.appendChild($avatar);
	$contentImg.appendChild($detailButton);
	$docFragment.appendChild($contentImg);
	$headerInfoWindowContent.appendChild($title);
	$headerInfoWindowContent.appendChild($closeButton);
	$infowindowDivContent.appendChild($headerInfoWindowContent);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
export const generateInfowindowContentDeposit = function (markerIndex) {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	let $headerInfoWindowContent = document.createElement("div");
	$headerInfoWindowContent.className = "flex items-center justify-between";
	let $closeButton = document.createElement("button");
	$closeButton.textContent = "X";
	$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
	$closeButton.addEventListener("click", () => {
		this.infoWindowSelected.close();
	});
	let $title = document.createElement("h5");
	let $avatar = document.createElement("img");
	$infowindowDivContent.style.cssText = "text-align: center";
	$title.textContent =
		markerIndex === 0 ? this.$t("Deposits.Form.StartDeposit") : this.$t("Deposits.Form.EndDeposit");
	let $contentImg = document.createElement("div");
	$contentImg.className = "flex items-center justify-end mt-4";
	$avatar.setAttribute("src", streetviewImg);
	$avatar.setAttribute("alt", "StreetView");
	$avatar.setAttribute("title", "StreetView");
	$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview-routing-map";
	$contentImg.appendChild($avatar);
	$docFragment.appendChild($contentImg);
	$headerInfoWindowContent.appendChild($title);
	$headerInfoWindowContent.appendChild($closeButton);
	$infowindowDivContent.appendChild($headerInfoWindowContent);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
export const generateInfowindowContentRoute = function (infoWindowData, infoWindow) {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.style.cssText = "text-align: center";
	let $headerInfoWindowContent = document.createElement("div");
	$headerInfoWindowContent.className = "flex items-center justify-between";
	let $closeButton = document.createElement("button");
	$closeButton.textContent = "X";
	$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
	$closeButton.addEventListener("click", () => {
		infoWindow.close();
		infoWindowData.setOptions({strokeWeight: 2, strokeOpacity: 2});
	});
	let $title = document.createElement("h5");
	$title.className = "mr-6";
	$title.textContent = infoWindowData.info.vehicle_id;
	$headerInfoWindowContent.appendChild($title);
	$headerInfoWindowContent.appendChild($closeButton);
	$infowindowDivContent.appendChild($headerInfoWindowContent);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
